export function subChineseStr(str, len) {
    if(!str) {
        return '';
    }
    let newStr = ''
        ,chinese
        ,chineseRegex = /[^\x00-\xff]/g
        ,strChinese = str.split('')
        ,strEnglish = str.split(' '); //英语以空格分
    str.match(chineseRegex) ? chinese = true : chinese = false;
    
    if(chinese) {
        if(len == 1) {
            newStr = str.slice(strChinese.length - 1);
        }else{
            newStr = str.slice(strChinese.length - 2);
        }
    }else{
        let englishStrLast = strEnglish[strEnglish.length - 1]
        ,englishStrNext = strEnglish[strEnglish.length - 2];
        
        if(len == 1) {
            newStr = englishStrLast.charAt(0);
        }else{
            englishStrNext ? newStr = englishStrNext.charAt(0) + englishStrLast.charAt(0) : newStr = englishStrLast.slice(0,2);
        }
    }
        
    return newStr;
}

export function formatTime(time) {
    if(time) {
        time = time.match(/.+:/g) ? time.match(/.+:/g)[0].replace(/T/g, ' ').replace(/-/g,'/').replace(/\d{4}\//g,'') : time;
        return time.slice(0,time.length - 1);
    }
    return time;
}


// WEBPACK FOOTER //
// ./src/components/Approval/format.js